import { useInfiniteQueryOptions } from './../query-options';
import { getNextPageParam } from './../get-next-page';
import {
  IEventOrChallengeOrMilestone,
  useQueryUserAchievements,
  useInfiniteQueryUserAchievements,
  useKeyUserAchievements,
} from '@ifit/gateway-wolf-athenaeum-service';

import { useRequiredRequestOptions } from '../query-options';
import { useInfiniteQueryDataMemo } from '../query-memo';
import { useInvalidateOnCallJavaScript } from '../native-bridge-refresh';

const useAchievementParams = params => {
  useInvalidateOnCallJavaScript('RefreshFavorites', useKeyUserAchievements);
  return {
    ...useRequiredRequestOptions(),
    ...params,
  };
};

export const useInfiniteAchievementsQuery = (
  type: IEventOrChallengeOrMilestone,
  perPage?: number,
  enabled = true,
) => {
  const opts = useInfiniteQueryOptions();
  const params = {
    ...opts,
    ...(type && { type: type }),
    ...(perPage && { perPage: perPage }),
  };
  return useInfiniteQueryDataMemo(
    useInfiniteQueryUserAchievements(useAchievementParams(params), {
      getNextPageParam,
      enabled,
      cacheTime: 5000,
    }),
  );
};

export const useAchievementsQuery = (
  type: IEventOrChallengeOrMilestone,
  year?: number,
) => {
  const params = {
    ...(year && { year: year }),
    ...(type && { type: type }),
  };
  return useQueryUserAchievements(useAchievementParams(params), {
    cacheTime: 5000,
  });
};
